import { LocalDate, LocalDateTime, LocalTime, ZonedDateTime, ZoneId } from '@js-joda/core'
import { DateFormat, jodaFormatPatternWithLocale } from './DateFormat'

// String is only accepted as an ISO string, e.g. 2019-07-09T12:00:00.000Z
export type JodaConvertible = LocalDate | LocalDateTime | LocalTime | ZonedDateTime | string | Date

/**
 * Date as an ISO String, e.g. 2019-07-09T12:00:00.000Z
 */
export function stringToZonedDateTime(date: string, timezone: ZoneId | string): ZonedDateTime | undefined {
  try {
    return ZonedDateTime.parse(date, jodaFormatPatternWithLocale(DateFormat.IsoZonedDateTime)).withZoneSameInstant(
      ZoneId.of(timezone.toString()),
    )
  } catch {
    return undefined
  }
}
